import { createSystem, defaultConfig, defineConfig, mergeConfigs } from '@chakra-ui/react';

import { breakpoints } from './breakpoints';
import { colours } from './colours';
import { fontsTheme } from './fonts';
import { styles } from './global';
import { recipes, slotRecipes } from './recipes';
import { semanticTokens } from './semanticTokens';

const customConfig = defineConfig({
  theme: { semanticTokens, recipes, slotRecipes, breakpoints, tokens: { colors: colours, ...fontsTheme } },
  globalCss: styles,
});

const config = mergeConfigs(defaultConfig, customConfig);

export const system = createSystem(config);
export { breakpoints } from './breakpoints';
